// Dependencies
import { EnumRadioField } from "@ucl/library";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";
import { useTaskTemplateForm } from "../useTaskTemplateForm";
import { multiStepTaskTypeForm } from "./multiStepsTaskTemplateForm";
import { singleStepTaskTypeForm } from "./singleStepTaskTemplateForm";
import { useBoltTaskTypeActionOptions } from "../useBoltTaskTemplateActionOptions";
import { BoltTaskTemplateFormProps } from "./CreateBoltTaskTemplateFormContainer";

export const EditBoltTaskTemplateFormContainer: FC<
  BoltTaskTemplateFormProps
> = ({
  taskTemplates,
  apiBaseUrl,
  updateTaskTemplates,
  assigneeOdataUrl,
  getAuthRequestHeader,
  richTextEditorsOutputTextType,
  errors,
  taskExecutionTypeData,
  updateTaskExecutionTypeData,
  showWorkflowTypeSelector = true,
  entityTypeOptions,
}) => {
  const { taskExecutionTypeOptions } = useBoltTaskTypeActionOptions();

  const { parentTaskTemplate, schemaFactory, updateParentTaskTemplate } =
    useTaskTemplateForm({
      taskTemplates,
      updateTaskTemplates,
    });

  if (!schemaFactory) {
    return;
  }

  return (
    <div className="bolt-task-type-form-content-container">
      <div>
        {showWorkflowTypeSelector && (
          <TooltipComponent
            content={
              "Switching the Workflow Type for an existing Task is not allowed. If you need to change the workflow type for this Task, please deactivate this Task Template and create a new Task Template."
            }
            target=".workflow-steps-selector label.bp5-radio:first-of-type"
            position="BottomCenter"
          >
            <TooltipComponent
              content={
                "Switching the Workflow Type for an existing Task is not allowed. If you need to change the workflow type for this Task, please deactivate this Task Template and create a new Task Template."
              }
              target=".workflow-steps-selector label.bp5-radio:last-of-type"
              position="BottomCenter"
            >
              <div className="workflow-steps-selector">
                <EnumRadioField
                  label="Workflow"
                  type="EnumRadio"
                  fieldName="hasMultiSteps"
                  fieldKey="hasMultiSteps"
                  disabled={true}
                  isRequired={true}
                  optionValues={[
                    { label: "Single Step", value: 1 },
                    { label: "Multi-step", value: 2 },
                  ]}
                  value={parentTaskTemplate?.hasMultiSteps ? 2 : 1}
                />
              </div>
            </TooltipComponent>
          </TooltipComponent>
        )}
        {parentTaskTemplate.hasMultiSteps
          ? multiStepTaskTypeForm(
              schemaFactory,
              apiBaseUrl,
              assigneeOdataUrl,
              taskTemplates,
              updateTaskTemplates,
              getAuthRequestHeader,
              richTextEditorsOutputTextType,
              errors
            )
          : singleStepTaskTypeForm(
              schemaFactory,
              apiBaseUrl,
              assigneeOdataUrl,
              parentTaskTemplate,
              updateParentTaskTemplate,
              getAuthRequestHeader,
              richTextEditorsOutputTextType,
              errors,
              taskExecutionTypeOptions,
              taskExecutionTypeData,
              updateTaskExecutionTypeData,
              entityTypeOptions
            )}
      </div>
    </div>
  );
};
